module.exports = __webpack_public_path__ + "static/img/stamp_close.e7a1d7c4.svg";